import request from '@/router/axios'

import OSS from 'ali-oss'
//生成唯一id
function uuid(length) {
	return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36)
}

//自定义阿里云oss上传  带参数是否鉴权等
const getOssParamsByCustom = function (data) {
	return request({
		url: '/admin/common/new/oss/uploadDir',
		method: 'post',
		data: data,
	})
}
const uploadOSSCustom = async function (file, ossParams) {
	let defaultParams = {
		acl: 1, //是否需要鉴权 1:需要 0.不需要 ，
		moduleName: 'safety', //项目名称 分销
		functionName: 'common', //功能名称 默认通用
	}
	if (ossParams) {
		defaultParams = Object.assign(defaultParams, ossParams)
	}
	const {data = {}} = (await getOssParamsByCustom(defaultParams)) || {}
	/**
   *     "data": {
        "accessKeyId": "STS.NTyyc5C3UBDc3eUfnpSM2oqcr",
        "accessKeySecret": "7DdVhpMKoeoFzarTbfwtJ7YvWv3UghkT3pwVoymqXMC3",
        "expiration": "2025-03-04T07:14:13Z",
        "securityToken": "CAISxAJ1q6Ft5B2yfSjIr5fMMtmBrux09YaIMUPkgm4lX8IegLTIkDz2IHhMe3VhAeEct/4+nGtY7/4alqV6R5pEQwnZdc9355gPGvdMizSb6aKP9rUhpMCPOwr6UmzWvqL7Z+H+U6muGJOEYEzFkSle2KbzcS7YMXWuLZyOj+wMDL1VJH7aCwBLH9BLPABvhdYHPH/KT5aXPwXtn3DbATgD2GM+qxsmt/Tvm5LDu0uO1gKim7NPnemrfMj4NfsLFYxkTtK40NZxcqf8yyNK43BIjvwu1PMYqG+W5IjHUgEKs0zea/Cw6NRqKxRibLUxGKNYvE43YxqpPnu5fe3VvPUtVYk9O0y3LAugdhxer97if1C1IQMfl6BREDQbDNiU1U1tKDlwL2ApYKFqSQQrIlc3ERKhQcLJtS6MDE7NJKbt9wfmfcQdpz0agAFnWM5dovJ9ldRXQMD1ABlZ5JPA7Q3/SU3z61cA5NGYLMCMJjfrLSJ/qM1ktQmVaWreRy3c9rOXFrKZLUPpSm6kE/MUCGkMsUFYJMoVhtHluPU0TxJoAOCpM7pYFq2FUrf5KTt9guRj8v2uYYHnrGkE5ZYWsX8XpVnTjJIVhBL3jyAA",
        "dir": "safety/common/dev/20250304",
        "region": "cn-hangzhou",
        "bucketName": "mempublic",
        "callBackUrl": "http://fx.m8bj.cn/admin/common/aliyun/oss/callback"
    }
   */
	let uploadConfig = data.data || {}

	let type = file.name.substring(file.name.lastIndexOf('.') + 1)
	// 修改文件命名规则
	// 获取原始文件名（不含扩展名）
	let originalFileName = file.name.substring(0, file.name.lastIndexOf('.'))
	// 生成4位UUID
	let shortUuid = uuid(4)
	// 新的文件名格式：原始文件名+4位UUID+扩展名
	let fileName = `${originalFileName}.${type}`
	let pathName = `${uploadConfig.dir}/${shortUuid}/${fileName}` //相对路径

	let ossUploadPraams = {
		bucket: uploadConfig.bucketName,
		// 如果这里使用的是本地获取的ststoken的参数，请将credentials.xxx手动替换为已获取到参数的具体数值
		accessKeyId: uploadConfig.accessKeyId,
		accessKeySecret: uploadConfig.accessKeySecret,
		stsToken: uploadConfig.securityToken,
		region: uploadConfig.region,
		// endpoint: "oss-cn-hangzhou.aliyuncs.com", // 显式指定 Endpoint
		// endpoint: `oss-${uploadConfig.region}.aliyuncs.com`,
		callBackUrl: uploadConfig.callBackUrl,
	}
	console.log('ossPraams', ossParams, ossUploadPraams)
	const client = new OSS(ossUploadPraams)
	const result = await client.put(pathName, file)
	console.log('uploadOSSCustom-result', result)
	return {
		key: defaultParams.acl == 0 ? result.url : result.name.replace('memsaas/', '/'),
		res: {data: {code: result.url ? 0 : 1}},
	}
}

export {uploadOSSCustom}
